import React from "react";
import PropTypes from "prop-types";

export class ErrorBoundary extends React.Component {
  static propTypes = {
    /**
     * Children covered by the error boundary
     */
    children: PropTypes.any,
    /**
     * Event handler when error occurs
     */
    onError: PropTypes.func
  };

  static defaultProps = {
    onError: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error, errorInfo) {
    //log the error;
    console.error("ErrorBoundary::Error ", error);
    this.props.onError({ error, errorInfo });
    this.setState({ error });
    sentryCaptureException(error, errorInfo);
  }

  render() {
    return this.state.error ? (
      <React.Fragment>
        {this.props.fallBackComponent ? (
          this.props.fallBackComponent
        ) : (
          <p style={{ color: "red" }}>There was an error</p>
        )}
      </React.Fragment>
    ) : (
      this.props.children
    );
  }
}

export const sentryCaptureException = async (error, errorInfo) => {
  try {
    const Sentry = await import("@sentry/react");
    Sentry.captureException(error, errorInfo);
  } catch (err) {
    console.info("Failed to load sentry in error boundry");
  }
};
